const UserChannelRoles = [
  { id: 'HOST',   name: 'resources.userChannels.roles.HOST' },
  { id: 'MEMBER_WRITE',       name: 'resources.userChannels.roles.MEMBER_WRITE' },
  { id: 'MEMBER_READ',       name: 'resources.userChannels.roles.MEMBER_READ' },
]

export default UserChannelRoles
